/* eslint-disable @typescript-eslint/no-unused-vars */
import { EditorOptions } from "@tiptap/core";
import BulletList from "@tiptap/extension-bullet-list";
import Color from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";
import Link from "@tiptap/extension-link";
import OrderedList from "@tiptap/extension-ordered-list";
import Placeholder from "@tiptap/extension-placeholder";
import TextStyle from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";

import { useEditorStyles } from "../styles";
import ColoredBlockquote from "./ColoredBlockquote";

export type ExtensionProps = {
  placeholder?: string;
};

const useExtensions = ({
  placeholder,
}: ExtensionProps): EditorOptions["extensions"] => {
  const { classes } = useEditorStyles({});
  return [
    StarterKit,
    Placeholder.configure({
      placeholder,
      showOnlyWhenEditable: false,
    }),
    ColoredBlockquote.configure({
      HTMLAttributes: {
        class: classes.blockquote,
      },
    }),
    Underline,
    TextStyle,
    Color,
    Highlight.configure({ multicolor: true }),
    OrderedList,
    BulletList,
    Link.configure({
      autolink: true,
      linkOnPaste: true,
      defaultProtocol: "https",
      HTMLAttributes: {
        class: classes.link,
      },
    }),
  ];
};

export default useExtensions;
